var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "冻结停车月卡",
        visible: _vm.visible,
        width: "640px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "before-close": _vm.handleCancel,
        "custom-class": "freeze-parking-card-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "freeze-alert" }, [
        _c("div", [
          _vm._v(
            "冻结期间月卡权益暂停，不计入有效使用期限；冻结结束后自动恢复生效。"
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "月卡开始时间、月卡到期时间不可手动修改，冻结期间对应的有效使用时间将顺延。"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "freeze-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品名称" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.productName, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "停车场名称" } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.display.parkName,
                    placement: "top",
                    disabled: !_vm.display.parkName,
                    "popper-class": "parking-name-tooltip",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { value: _vm.display.parkName, disabled: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "车牌号" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.plateNo, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "月卡开始时间" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.validStartTime, disabled: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "field-tip" }, [
                _vm._v("月卡原始开始时间不可修改。"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "当前到期时间" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.validEndTime, disabled: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "field-tip" }, [
                _vm._v("当前月卡实际到期时间，冻结操作前保持不变。"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "冻结时间", prop: "freezeStart" } },
            [
              _c(
                "div",
                { staticClass: "freeze-time-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      format: "yyyy/MM/dd",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "",
                      "picker-options": _vm.freezePickerOptions,
                    },
                    on: { change: _vm.onFreezeTimeChange },
                    model: {
                      value: _vm.form.freezeStart,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "freezeStart", $$v)
                      },
                      expression: "form.freezeStart",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "freeze-time-sep" }, [
                    _vm._v("至"),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      format: "yyyy/MM/dd",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "",
                      "picker-options": _vm.freezePickerOptions,
                    },
                    on: { change: _vm.onFreezeTimeChange },
                    model: {
                      value: _vm.form.freezeEnd,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "freezeEnd", $$v)
                      },
                      expression: "form.freezeEnd",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "field-tip" }, [
                _vm._v(
                  "支持选择冻结开始时间、冻结结束时间。冻结开始后月卡立即暂停生效，冻结结束后自动恢复。"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "冻结原因" } },
            [
              _c("el-input", {
                staticClass: "reason-textarea",
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "100",
                  "show-word-limit": "",
                  placeholder: "请输入冻结原因",
                },
                model: {
                  value: _vm.form.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "上传附件", required: "" } }, [
            _c(
              "div",
              {
                staticClass: "attach-box",
                on: { click: _vm.chooseAttachment },
              },
              [
                _vm.form.attachment
                  ? [
                      _vm.form.attachment.extName !== "pdf"
                        ? _c("img", {
                            staticClass: "attach-preview",
                            attrs: { src: _vm.form.attachment.url, alt: "" },
                          })
                        : _c("i", {
                            staticClass: "el-icon-document attach-pdf",
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-name" }, [
                        _vm._v(_vm._s(_vm.form.attachment.fileName)),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "attach-plus" }, [_vm._v("+")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-link" }, [
                        _vm._v("从素材库选择附件"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-hint" }, [
                        _vm._v("支持 JPG、PNG、PDF，单个文件不超过1MB"),
                      ]),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field-tip" }, [
              _vm._v("附件为必填项，用于留存冻结申请/审批凭证。"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认冻结")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }